var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"backtop_wrap flexcenter",on:{"click":_vm.gototop}},[_c('img',{attrs:{"src":require("../../assets/image/backtop.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }